module.exports = __webpack_public_path__ + "static/media/Iran_Venezuela.8ec3bfb2.svg";